import React from 'react';

import { useAppPageTheme } from '../../hooks/useAppPageTheme.js';
import '../../styles/appPageCream.big-top.scss';

/**
 * Wraps legacy app pages with the big-top cream shell when the route is themed.
 *
 * @param {object} props
 * @param {string} props.pageKey — themeRegistry pageClasses key
 * @param {string} [props.className]
 */
export default function AppPageShell({ pageKey, className, children }) {
  const { isThemed, shellClass } = useAppPageTheme(pageKey);
  const combinedClass = [isThemed ? shellClass : null, className].filter(Boolean).join(' ') || undefined;

  if (!combinedClass) {
    return children;
  }

  return <div className={combinedClass}>{children}</div>;
}
